<script lang="ts">
  import { rhythmSkillStringToRhythmString } from 'exercises/src/uTheory.Notation/rhythmSkillStringToRhythmString';

  import RhythmSpan from 'exercises/src/uTheory.Notation/RhythmSpan.svelte';
  import { autorun, IReactionDisposer } from 'mobx';
  import type SectionKnowledgeSkillStore from 'shared/src/section/sectionKnowledge/section.knowledge.skill.store';
  import type { UserSkillStore } from 'shared/src/user/userKnowledge/user.skill.store';
  export let skill: SectionKnowledgeSkillStore | UserSkillStore;

  export let color: string | undefined = undefined;
  export let stroke: string | undefined = undefined;

  let title: string;
  let useRhythmTitle: boolean = false;
  let destroyer: IReactionDisposer;
  let meters: string[] = [];

  let rhythmString: string = '';

  const skillTitleMeterStrings = ['S:', 'C:', 'H:'] as const;

  $: {
    if (destroyer) destroyer();
    destroyer = autorun(() => {
      title = skill.title;
      const rhythmType = skillTitleMeterStrings.find((s) => title.includes(s));
      useRhythmTitle = !!skill.definition.rhythm;
      rhythmString = useRhythmTitle ? rhythmSkillStringToRhythmString(skill.textId) : '';
      switch (rhythmType) {
        case 'S:':
          meters = ['2/4', '3/4', '4/4'];
          break;
        case 'C:':
          meters = ['6/8', '9/8', '12/8'];
          break;
        case 'H:':
          meters = ['2/2', '3/2', '4/2'];
          break;
        default:
          meters = [];
      }
    });
  }

  $: style = color ? `color: ${color}; ` : '';
</script>

<span {style}>
  {#if useRhythmTitle}
    <RhythmSpan timeSignatures={meters} {rhythmString} {color} {stroke} />
  {:else}
    {title}
  {/if}
</span>
